/**
 * Product Card Carousel — Splide.js
 * Include in: assets/product-carousel-splide.js
 *
 * Requires Splide.js loaded before this file:
 * <script src="{{ 'splide.min.js' | asset_url }}" defer></script>
 * (download from https://splidejs.com and place in assets/)
 */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-carousel]').forEach(function (card) {
    const splide = new Splide(card.querySelector('[data-carousel-splide]'), {
      type       : 'loop',       // infinite wrap-around
      perPage    : 1,
      perMove    : 1,
      arrows     : false,
      pagination : false,
      drag       : true,
      speed      : 380,
      easing     : 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    });

    // Update the custom progress bar on each slide move
    const fill  = card.querySelector('[data-carousel-fill]');
    const total = card.querySelectorAll('.splide__slide:not(.splide__slide--clone)').length;

    splide.on('move', function (newIndex) {
      const fillW = (100 / total).toFixed(3);
      const fillL = ((newIndex / total) * 100).toFixed(3);
      fill.style.width = fillW + '%';
      fill.style.left  = fillL + '%';
    });

    splide.mount();
  });
});